import { Pagination, PaginationProps, Row } from "antd";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { updateCurrentPage as AdminUpdateCurrentPage } from "redux/reducers/StudentsTableSlice";
import { updateCurrentPage as RaterUpdateCurrentPage } from "redux/reducers/SRSApplicantSlice";
import prevIcon from "assets/icons/pagination-prev.svg";
import nextIcon from "assets/icons/pagination-next.svg";
import { useEffect, useState } from "react";
import useBreakpoints from "utils/hooks/useBreakpoints";
import { TABLE_TYPE } from "utils/Constants";

type TableFooterType = {
  paginationProps: any;
  tableType: TABLE_TYPE;
};

export const paginationBreakpoints = {
  xs: {
    small: true
  },
  sm: {
    small: true
  },
  md: {
    small: false
  }
};

const TableFooter = ({ paginationProps, tableType }: TableFooterType): JSX.Element => {
  const dispatch = useAppDispatch();
  const { STUDENTS } = useAppSelector(state => state.students);
  const { currentPage: srsCurrentPage } = useAppSelector(state => state.srsApplicants);
  const [currentPage, setCurrentPage] = useState<number>(0);

  const { mappedValue: mappedWidths } = useBreakpoints(paginationBreakpoints);
  const newPaginationProps = { ...paginationProps };

  if (mappedWidths?.small) {
    newPaginationProps.showTotal = (total: number) => {
      return `Total ${total} items`;
    };
  }

  useEffect(() => {
    getCurrentPage();
  }, []);

  const getCurrentPage = () => {
    if (tableType == TABLE_TYPE.STUDENTS) {
      setCurrentPage(STUDENTS.currentPage);
    } else if (tableType == TABLE_TYPE.SRS) {
      setCurrentPage(srsCurrentPage);
    }
  };

  const onChangePagination: PaginationProps["onChange"] = (page: number) => {
    if (tableType == TABLE_TYPE.STUDENTS) {
      dispatch(AdminUpdateCurrentPage({ currentPage: page, role: tableType }));
    } else if (tableType == TABLE_TYPE.SRS) {
      dispatch(RaterUpdateCurrentPage(page));
    }
    setCurrentPage(page);
  };

  const itemRender: PaginationProps["itemRender"] = (pageNumber, type, originalElement) => {
    if (type === "prev") {
      return (
        <a href="#" className="pagination-link">
          <img src={prevIcon} alt="Back to the previous page" />
        </a>
      );
    }
    if (type === "next") {
      return (
        <a href="#" className="pagination-link">
          <img src={nextIcon} alt="Go to the next page" />
        </a>
      );
    }
    if (type === "jump-prev" || type === "jump-next") {
      return originalElement;
    } else {
      const isNavigated = currentPage === pageNumber;
      return (
        <a className="pagination-link">
          <span className="sr-only">Page </span>
          {pageNumber}
          {isNavigated && <span className="sr-only">, Current</span>}
        </a>
      );
    }
  };

  return (
    <Row justify="space-between">
      <div></div>
      <nav role="navigation" aria-label="Pagination Navigation">
        <Pagination
          {...newPaginationProps}
          onChange={onChangePagination}
          itemRender={itemRender}
          showSizeChanger={false}
          size={mappedWidths?.small ? "small" : "default"}
        />
      </nav>
    </Row>
  );
};

export default TableFooter;
